import {
  SET_CATEGORIES,
  SET_TRADE,
  SET_CATEGORIES_FETCHING,
} from '../../actions/categories'
import type {
  CATEGORIES_LIST_TYPE,
  TRADE_LIST_TYPE,
} from '../../actions/categories'

type State = {
  categoriesList: Object[],
  tradeList: Object[],
}

const initialState: State = {
  categoriesList: [],
  trade:[],
}

type Action =
  | CATEGORIES_LIST_TYPE
  | TRADE_LIST_TYPE
  | SET_CATEGORIES_FETCHING

export default function categoriesReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case SET_CATEGORIES: {
      const { categories } = action.payload
      return {
        ...state,
        categoriesList: categories,
      }
    }
    case SET_TRADE: {
          const { trade } = action.payload
          return {
              ...state,
              tradeList: trade,
          }
    }
    case SET_CATEGORIES_FETCHING: {
      return {
        ...state,
        isFetching: action.payload,
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/categories/index.js